// src/components/job-details/JobDetailsContent.jsx
import React from "react";

import JobDetailsDetailsTab from "./JobDetailsDetailsTab";
import JobDetailsStagesTab from "./JobDetailsStagesTab";
import MatchesTabContent from "./MatchesTabContent"; // ✅ correct import
import JobDetailsActivitiesTab from "./JobDetailsActivitiesTab"; // ✅ you already have this
//import JobDetailsPlaceholder from "./JobDetailsPlaceholder"; // ✅ needed (you reference it)

export default function JobDetailsContent({
  tab,
  data,
  fieldOptions,
  stageFilter = "all",
  candidateFilter = "all",
  stageRows = [],
  onMoveCandidatesToStage,
  onDeleteCandidatesFromStage,
  onEditHeader,
  onAddToStage,
  onMoveMatchCandidatesToStage,
  onSaveDetails,
  onAddDocument,
  documentsUploading,
  documentsError,
  prefetchedMatchRows,
  matchesRefreshKey,
  onMatchRowsChange,
  showDocuments = true,
  isAdminUser = false,
  canDeleteCandidates = false,
  currentUserRole = "",
}) {
  if (tab === "details") {
    return (
      <JobDetailsDetailsTab
        data={data}
        fieldOptions={fieldOptions}
        onSaveDetails={onSaveDetails}
        onAddDocument={onAddDocument}
        documentsUploading={documentsUploading}
        documentsError={documentsError}
        showDocuments={showDocuments}
      />
    );
  }

  if (tab === "stages") {
    return (
      <JobDetailsStagesTab
        data={data}
        selectedStage={stageFilter}
        rows={stageRows}
        onMoveCandidatesToStage={onMoveCandidatesToStage}
        onDeleteCandidatesFromStage={onDeleteCandidatesFromStage}
        onEditHeader={onEditHeader}
        onAddToStage={onAddToStage}
        isAdminUser={isAdminUser}
        canDeleteCandidates={canDeleteCandidates}
        currentUserRole={currentUserRole}
      />
    );
  }

  if (tab === "matches") {
    return (
      <MatchesTabContent
        data={data}
        selectedFilter={candidateFilter}
        onEditHeader={onEditHeader}
        onAddToStage={onAddToStage}
        onMoveCandidatesToStage={onMoveMatchCandidatesToStage}
        onDeleteCandidates={onDeleteCandidatesFromStage}
        prefetchedRows={prefetchedMatchRows}
        refreshKey={matchesRefreshKey}
        onRowsChange={onMatchRowsChange}
        canDeleteCandidates={canDeleteCandidates}
        currentUserRole={currentUserRole}
      />
    );
  }

  // ✅ Activities now renders the real tab component
  if (tab === "activities") {
    return (
      <JobDetailsActivitiesTab
        data={data}
        onEditHeader={onEditHeader}
      />
    );
  }

  return null;
}
